import React, { useEffect, useContext, useState } from 'react'
import { TenantContext } from 'tenant/TenantContext';
import useExternalScripts from 'util/useExternalScripts';
import { API } from 'api/API';
import { PAYMENTINTENT_TOKEN_URL } from 'config/config';
import { extractError } from 'api/ErrorUtil';
import { CheckoutContext } from '../CheckoutContext';
import { getPaymentStatus } from 'util/Lookup';
import _ from "lodash";

const PayByElavon = ({ paymentFunction, formData }) => {

    const { businessConfig } = useContext(TenantContext);

    useExternalScripts(businessConfig.elavonLightboxUrl);

    const { paymentDispatch, paymentData } = useContext(CheckoutContext)
    
    const handlePaymentResult= async (payer, commitmentItems,paymentResponse, error, paymentStatus, paymentIntentId, paymentCorrespodence,receiptInCompanyName) => {
        //console.log("Payment Response",paymentResponse);
        //At this time it means payment was approved. save payment result
        let paymentUpdateResp = {};
        try {
            //update payment result in the database
            paymentUpdateResp = await API.put(PAYMENTINTENT_TOKEN_URL, {
                gatewayResponse: paymentResponse,
                paymentStatus: paymentStatus,
                payer: payer,
                commitmentItems: commitmentItems,
                customerConsentsToPayPfFees: formData.customerConsentsToPayPfFees,
                paymentSourceType: formData.paymentSourceType,
                paymentIntentId: paymentIntentId,
                paymentCorrespodence: paymentCorrespodence,
                receiptInCompanyName: receiptInCompanyName
            });
        } catch (err) {
            let errors = extractError(err);
            errors.message = "Payment Status was: "+getPaymentStatus(paymentStatus)+". However, Error was encountered during saving the payment information: "+errors.message
            +". Share this error message with the administrator of the site. Payment Intent Id: "+paymentIntentId 
            paymentDispatch({ type: 'PAYMENT_ERROR', payload: { errors: errors } });
            return;
        }

        if (paymentStatus === 'PAYMENT_ERROR'){
            paymentDispatch({ type: paymentStatus, payload: { errors: { message: error } } });
            return;
        } else if (paymentStatus === 'PAYMENT_CANCELLED' ){
            paymentDispatch({ type: paymentStatus, payload: { errors: { message: 'Payment was cancelled' } } });
            return;
        } else if (paymentStatus === 'PAYMENT_DECLINED'){
            paymentDispatch({ type: paymentStatus, payload: { errors: { message: 'Payment was declined. Please try another card' } } });
            return;
        } else if (paymentStatus === 'PAYMENT_SUCCEEDED'){
            paymentDispatch({ type: 'PAYMENT_SUCCEEDED', payload: {paymentResponse: paymentUpdateResp.data} });
            return;
        }
        
    }

    const openLightbox = async () => {

        let txTokenResp = null;
        
        const commitmentItems = formData.paymentCartItems.map(paymentCartItem => ({
            commitmentId: paymentCartItem.id,
            accountNumber: paymentCartItem?.account?.number,
            accountType: paymentCartItem?.accountType?.accountType,
            commitmentType: paymentCartItem.commitmentType,
            commitmentPaymentAmount: paymentCartItem.itemDetail.amountDue,
            paymentItems: paymentCartItem.itemDetail.lineItems,
            committmentFrequency: !_.isEmpty(paymentCartItem.itemDetail.frequency)?paymentCartItem.itemDetail.frequency:null
        }));


        try {
            txTokenResp = await API.post(PAYMENTINTENT_TOKEN_URL, {
                payer: formData.payer,
                commitmentItems: commitmentItems,
                customerConsentsToPayPfFees: formData.customerConsentsToPayPfFees,
                paymentSourceType: formData.paymentSourceType,
                paymentCardId: formData.paymentCardId,
                paymentCorrespodence: formData.paymentCorrespodence,
                receiptInCompanyName: formData.receiptInCompanyName
            });

            if (!_.isEmpty(formData.paymentCardId)){
                //this means that payment was via a token
                paymentDispatch({ type: 'PAYMENT_SUCCEEDED', payload: {paymentResponse: txTokenResp.data} });
                return;
            }


        } catch (error) {
            let errors = extractError(error);
            paymentDispatch({ type: 'PAYMENT_ERROR', payload: { errors: errors } });
            return
        }

        let paymentFields = {
            ssl_txn_auth_token: txTokenResp.data.gatewayPaymentIntent.id,
        };

        let callback = {
            onError: function (error) {
                handlePaymentResult(formData.payer, commitmentItems, null, error, 'PAYMENT_ERROR',txTokenResp.data.paymentIntentId, formData.paymentCorrespodence,formData.receiptInCompanyName);
            },
            onCancelled: function () {
                handlePaymentResult(formData.payer, commitmentItems, null, null, 'PAYMENT_CANCELLED',txTokenResp.data.paymentIntentId,formData.paymentCorrespodence,formData.receiptInCompanyName);
            },
            onDeclined: function (response) {
                handlePaymentResult(formData.payer, commitmentItems, response, null, 'PAYMENT_DECLINED',txTokenResp.data.paymentIntentId, formData.paymentCorrespodence,formData.receiptInCompanyName);
            },
            onApproval: function (response) {
                handlePaymentResult(formData.payer, commitmentItems, response, null, 'PAYMENT_SUCCEEDED',txTokenResp.data.paymentIntentId, formData.paymentCorrespodence,formData.receiptInCompanyName);
            }
        };

        window['PayWithConverge'].open(paymentFields, callback);
        return false;
    }

    useEffect(() => {
        paymentFunction.current = openLightbox;
    }, [openLightbox, paymentData, formData])

    return 
}

export default PayByElavon